import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { PATIENT_PROFILE_QUERY_KEY, UPDATE_PATIENT_PROFILE_KEY } from '../constants';
import {
  UpdatePatientProfileParams,
  UpdatePatientProfileVariables,
} from '../components/shared/ProfileDetails/ProfileDetails.type';
import { updatePatientProfile } from '../services';

function useMutationUpdatePatientProfile(
  onSuccess: () => void,
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async (props: UpdatePatientProfileParams): Promise<any> => {
    return await updatePatientProfile(props);
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (err: unknown, _id: string, _context: UpdatePatientProfileVariables): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (
    _data: string,
    _variables: UpdatePatientProfileVariables,
    _context: any,
  ): Promise<void> => {
    void queryClient.invalidateQueries([PATIENT_PROFILE_QUERY_KEY]);
    onSuccess?.();
  };

  return useMutation<string, unknown, any, any>([UPDATE_PATIENT_PROFILE_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationUpdatePatientProfile;
